import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MediaUploader, MediaUploadResult } from '@vendasta/forms';
import { Observable } from 'rxjs';

export const defaultImageMaxSize = 5242880; // 5MB
export const defaultSupportedImageExtensions = ['png', 'jpg', 'jpeg', 'gif'];
export const defaultPreviewBackgroundColor = '#ba68c8'; // purple

@Injectable()
export class ImageUploadService implements MediaUploader {
  constructor(private httpClient: HttpClient) {}

  public upload(file: File): Observable<MediaUploadResult> {
    const body = new FormData();
    body.append('file', file);
    return this.httpClient.post('/fileupload/', body).pipe(
      map((result: { file: { fileurl: string; mimetype: string; filename: string } }) => {
        return { url: result.file.fileurl };
      }),
    );
  }
}
